import React from 'react';
import { useTranslation } from 'react-i18next';
import './CaptionModeInput.scss';
import ToggleButton from '../../ProducerComponents/ProducerControlPanel/Widgets/ToggleButton';
import useProject from '../../../hooks/useProject';
import { CaptionModeEnum } from '../../../types/enums/CaptionModeEnum';
import Help from '../../Help/Help';

const CaptionModeInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();

  let bgColour = project.encoder.overlayBackgroundColour;
  let bgTransparency = project.encoder.overlayBackgroundTransparency;
  let fontColour = project.encoder.overlayFontColour;
  let fontTransparency = project.encoder.overlayFontTransparency;

  const onChange = (value: string | number | boolean) => {
    if(value === CaptionModeEnum.Closed){
      bgColour = '#000000';
      bgTransparency = 0.75;
      fontColour = '#FFFFFF'
      fontTransparency = 1;
    }

    if (project.stream?.sourceLanguageIsoCode === project.encoder?.languageIsoCode) {
      updateStream({
        captionMode: value,
        overlayBackgroundColour: bgColour,
        overlayBackgroundTransparency: bgTransparency,
        overlayFontColour: fontColour,
        overlayFontTransparency: fontTransparency,
      });
    } else {
      updateEncoder(project.encoder, {
        captionMode: value,
        overlayBackgroundColour: bgColour,
        overlayBackgroundTransparency: bgTransparency,
        overlayFontColour: fontColour,
        overlayFontTransparency: fontTransparency,
      });
    }
  };

  return (
    <div className="caption-mode-input">
      <div className="input-title">
        {t('producer.inputs.caption-mode.title')}
        <Help
          title="Caption Type"
          text="Open overlaid embedded captions or CEA 608/708 Closed captions are available for both Human and AI captions.<br/></br><b>Open Captions:</b><br/>Captions are embedded in the stream and visible at all times.<br/></br><b>Closed Captions:</b><br/>CEA 608/708 Closed Captions are available on compatible players by turning the CC button on or off.<br/><br/>Please note, only Western character set languages are available if you select Closed Captions."
        />
      </div>
      <ToggleButton
        leftText={t('producer.inputs.caption-mode.open')}
        leftValue={CaptionModeEnum.Open}
        leftButtonClassName={`caption-mode-button ${
          project.encoder?.captionMode === CaptionModeEnum.Open
            ? 'control-panel-button-selected-button'
            : null
        }`}
        leftContentClassName="caption-mode-text"
        rightText={t('producer.inputs.caption-mode.closed')}
        rightValue={CaptionModeEnum.Closed}
        rightButtonClassName={`output-mode-button ${
          project.encoder?.captionMode === CaptionModeEnum.Closed
            ? 'control-panel-button-selected-button'
            : null
        }`}
        rightContentClassName="caption-mode-text"
        footerText={t(`producer.inputs.caption-mode.footer`)}
        isReadOnly={false}
        onSelection={onChange}
        leftAccessibilityName={t('producer.inputs.caption-mode.accessibility.open')}
        rightAccessibilityName={t('producer.inputs.caption-mode.accessibility.closed')}
      />
    </div>
  );
};

export default React.memo(CaptionModeInput);
